import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon ProfileIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const ProfileIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 70 70">
      <g>
        <g id="Group_3994" transform="translate(2568 6516.827)">
          <g id="Ellipse_18" transform="translate(6.43)">
            <g>
              <ellipse
                fill="none"
                cx={-2539.45}
                cy={-6492.74}
                rx={9.6}
                ry={9.6}
              />
            </g>
            <g>
              <path d="M-2539.45-6483.14c-5.29,0-9.6-4.31-9.6-9.6s4.31-9.6,9.6-9.6s9.6,4.31,9.6,9.6 S-2534.15-6483.14-2539.45-6483.14z M-2539.45-6500.34c-4.19,0-7.6,3.41-7.6,7.6s3.41,7.6,7.6,7.6c4.19,0,7.6-3.41,7.6-7.6 S-2535.26-6500.34-2539.45-6500.34z" />
            </g>
          </g>
          <g id="Path_1892" transform="translate(-11.653 16.134)">
            <g>
              <path
                fill="none"
                d="M-2521.95-6496.34c9.6,0,16.6,3.5,16.6,11.4c0,9.8-32,10.2-32,0 C-2537.35-6492.84-2531.55-6496.34-2521.95-6496.34z"
              />
            </g>
            <g>
              <path d="M-2521.95-6494.34c-4.5,0-7.9,0.8-10.2,2.4c-2.2,1.5-3.3,3.8-3.3,7c0,0.7,0.3,1.3,0.8,1.9 c0.6,0.7,1.6,1.3,2.9,1.8c2.6,1.1,6.2,1.7,10.1,1.7c3.9,0,7.7-0.6,10.4-1.7c1.3-0.5,2.3-1.2,3-1.9c0.6-0.6,0.8-1.2,0.8-1.9 c0-1.6-0.3-2.9-1-4.1c-0.6-1.1-1.6-2.1-2.8-2.8C-2513.65-6493.54-2517.45-6494.34-2521.95-6494.34 M-2521.95-6496.34 c9.6,0,16.6,3.5,16.6,11.4c0,9.8-32,10.2-32,0C-2537.35-6492.84-2531.55-6496.34-2521.95-6496.34z" />
            </g>
          </g>
        </g>
      </g>
    </Icon>
  )
}
export default ProfileIcon
